import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, buttonField, controlledField, checkboxField} from '../../core/redux/form'
import {linkFinder, relFilter} from '../../core/links'
import extract, {replace} from '../../core/extract'
import phonez, {phoneField} from '../../core/phonez'
import ButtonToggle from '../../core/components/ButtonToggle'
import RadioToggle from '../../core/components/RadioToggle'
import Icon from '../../core/components/Icon'
import LoaderButton from '../../core/components/LoaderButton'
import AnswerForm from '../../satisfaction/components/AnswerForm'
import {
    EMIT_CALL_TO_CMD_UPDATED,
    updateEmitCallToCmd,
    sendEmitCallToCmd,
    sendRequestInterventionCmd,
    sendAcceptInterventionCmd,
    sendRefuseInterventionCmd,
    loadTicket,
    chooseIfSendNotificationWhenInterventionAccepted
} from '../actions'
import {
    EMIT_CALL_TO_ASSIGNEE_HINTS,
    EMIT_CALL_TO_CALLER_HINTS,
    INTERVENTION_CMD_TYPES,
    createValidator,
    mediumToContactMedium,
    plainContactToContactMedium,
    EmitCallToCmd
} from '../models'
import i18n from '../i18n'
import style from './EmitCallToModal.less'

import SendInterventionInfoToAssignee from './SendInterventionInfoToAssignee'

function assigneeHintFilter(_links) {
    return (hint) => {
        switch (hint) {
            case 'assigneeInterventionTransfer':
                return !!_links.find(linkFinder('RequestIntervention'))
            default:
                return true
        }
    }
}

function restrictMediums(assignee, caller, contactToCallback, callType) {
    switch (callType) {
        case 'EmitCallToAssignee':
            const mediums = []
            mediums.push(...assignee.phones.map(plainContactToContactMedium('Phone')))
            mediums.push(...assignee.emails.map(plainContactToContactMedium('Mail')))
            mediums.push(...assignee.fax.map(plainContactToContactMedium('Fax')))
            return mediums
        case 'EmitCallToCaller':
            return caller.medium.map(mediumToContactMedium)
        case 'EmitCallToContactToCallback':
            return [mediumToContactMedium(contactToCallback.medium)]
        default:
            return []
    }
}

function restrictRecipient(assignee, caller, contactToCallback, callType) {
    switch (callType) {
        case 'EmitCallToAssignee':
            if (assignee.assigneeType == 'ProviderCompany') {
                return {
                    namez: {
                        value: assignee.name,
                        nameType: 'PoorName'
                    },
                    status: 'ProviderCompany',
                    personaType: 'UnClassifiedPersona'
                }
            }
            return {
                provider: assignee,
                personaType: 'ProviderPersona'
            }
        case 'EmitCallToCaller':
            return {
                namez: {
                    value: caller.name,
                    nameType: 'PoorName'
                },
                personaType: 'UnClassifiedPersona'
            }
        case 'EmitCallToContactToCallback':
            return {
                namez: {
                    value: contactToCallback.name,
                    nameType: 'PoorName'
                },
                personaType: 'UnClassifiedPersona'
            }
        default:
            return {
                namez: {
                    nameType: 'PoorName'
                },
                personaType: 'UnClassifiedPersona'
            }
    }
}

function restrictCallTypes(assignee, caller, contactToCallback) {
    var callTypes = []

    if (assignee === undefined || caller === undefined) {
        callTypes.push('EmitCall')
    }
    if (assignee && caller) {
        callTypes.push('EmitCall')
    }
    if (assignee) {
        callTypes.push('EmitCallToAssignee')
    }
    if (caller) {
        callTypes.push('EmitCallToCaller')
    }
    if (contactToCallback) {
        callTypes.push('EmitCallToContactToCallback')
    }

    return callTypes
}

function restrictHints(ticket, callType) {
    switch (callType) {
        case 'EmitCallToAssignee':
            return EMIT_CALL_TO_ASSIGNEE_HINTS.filter(assigneeHintFilter(ticket._links))
        case 'EmitCallToCaller':
            return EMIT_CALL_TO_CALLER_HINTS
        case 'EmitCallToContactToCallback':
            return EMIT_CALL_TO_CALLER_HINTS
        default:
            return []
    }
}

function restrictInterventionCmdTypes(ticket, hint) {
    switch (hint) {
        case 'assigneeInterventionTransfer':
            return INTERVENTION_CMD_TYPES.filter(relFilter(ticket._links))
        default:
            return []
    }
}

class EmitCallToModal extends Component {
    static propTypes = {
        assignee: PropTypes.object,
        caller: PropTypes.object,
        contactToCallback: PropTypes.object,
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            hints: [],
            interventionCmdTypes: []
        }
    }

    componentWillMount() {
        const {dispatch, ticket, assignee, caller, contactToCallback} = this.props

        const callTypes = restrictCallTypes(assignee, caller, contactToCallback)
        const callType = callTypes[0]
        const hints = restrictHints(ticket, callType)

        const recipient = restrictRecipient(assignee, caller, contactToCallback, callType)
        const mediums = restrictMediums(assignee, caller, contactToCallback, callType)
        const medium = undefined
        const comment = undefined

        dispatch(updateEmitCallToCmd({recipient, medium, comment}))
        this.setState({callTypes, callType, mediums, hints})
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.ticket && this.props.ticket && nextProps.ticket.uid !== this.props.ticket.uid)
            || (nextProps.assignee && this.props.assignee && nextProps.assignee.uid !== this.props.assignee.uid)
            || nextProps.caller !== this.props.caller
            || nextProps.contactToCallback !== this.props.contactToCallback) {
            const {dispatch, ticket, assignee, caller, contactToCallback} = nextProps

            const callTypes = restrictCallTypes(assignee, caller, contactToCallback)
            const callType = callTypes[0]
            const hints = restrictHints(ticket, callType)

            const recipient = restrictRecipient(assignee, caller, contactToCallback, callType)
            const mediums = restrictMediums(assignee, caller, contactToCallback, callType)

            const medium = undefined
            const comment = undefined
            const hint = undefined
            const interventionCmdTypes = []
            const interventionCmdType = undefined
            const interventionAcceptedClicked = undefined

            dispatch(updateEmitCallToCmd({recipient, medium, comment, interventionAcceptedClicked}))
            this.setState({callTypes, callType, mediums, hints, hint, interventionCmdTypes, interventionCmdType})
        }

    }

    _sendCmd() {
        const {dispatch} = this.props
        const {hint, interventionCmdType} = this.state

        var sendPromise

        if (hint == 'assigneeInterventionTransfer') {
            sendPromise = dispatch(sendRequestInterventionCmd()).then(() => {
                switch (interventionCmdType) {
                    case 'AcceptIntervention':
                        return dispatch(sendAcceptInterventionCmd())
                    case 'RefuseIntervention':
                        return dispatch(sendRefuseInterventionCmd())
                }
            })
        } else {
            sendPromise = dispatch(sendEmitCallToCmd())
        }

        return sendPromise.then(() => {
            return dispatch(loadTicket())
        })
    }

    _validate() {
        const {form} = this.props
        const {answerForm} = this.refs

        return form.validate() && (!answerForm || answerForm.validate())
    }

    _isValid() {
        const {form, acceptInterventionCmd} = this.props
        return form.isValid() && acceptInterventionCmd.accepted
    }

    _hide = () => {
        const {onHide} = this.props
        onHide()
    }

    _send() {
        const {answerForm} = this.refs

        return Promise.resolve().then(() => {
            return answerForm && answerForm.sendAction()
        }).then(() => {
            return this._sendCmd()
        }).then(this._hide)
    }

    _toggleCallType(callType) {
        const {dispatch, ticket, assignee, caller, contactToCallback} = this.props

        if (callType) {
            const recipient = restrictRecipient(assignee, caller, contactToCallback, callType)
            const mediums = restrictMediums(assignee, caller, contactToCallback, callType)
            const hints = restrictHints(ticket, callType)
            const medium = undefined
            const comment = undefined
            const hint = undefined

            dispatch(updateEmitCallToCmd({recipient, medium, comment}))
            this.setState({callType, mediums, hints, hint})
        }
    }

    emailStuff = () => {
        const {assignee, form} = this.props
        const {interventionCmdTypes, interventionCmdType} = this.state

        return interventionCmdTypes.length !== 0 && interventionCmdType === 'AcceptIntervention'
            && (<div>
                <h5>{i18n.bonDintervention}</h5>
                <Row>
                    <Col sm={9} smOffset={3}>
                        <SendInterventionInfoToAssignee assignee={assignee} />
                    </Col>
                </Row>
            </div>)
    }

    render() {
        const {dispatch, form, cmd, ticket, assignee, caller, contactToCallback, ...others} = this.props
        const {callTypes, callType, mediums, hints, hint, interventionCmdTypes, interventionCmdType} = this.state
        const {answerForm} = this.refs

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const inputAddon = (icon) => (
            <Icon icon={icon} size='xs'/>
        )

        const mediumInputButton = (medium) => (
            <Button
                {...buttonField(form.medium(), medium)}>
                <Icon icon='radio' size='xs'/>
            </Button>
        )

        const mediumField = (field, type) => {
            const disabled = field.value && field.value.contactMediumType != type || false
            var value

            switch (type) {
                case 'Phone':
                    value = field.value && field.value.phone
                    break
                case 'Mail':
                    value = field.value && field.value.mail
                    break
                case 'Fax':
                    value = field.value && field.value.fax
                    break
            }

            function onChange(eventOrValue) {
                var value
                if (eventOrValue && eventOrValue.target) {
                    value = eventOrValue.target.value
                } else {
                    value = eventOrValue
                }

                var medium
                switch (type) {
                    case 'Phone':
                        medium = value && {phone: value, contactMediumType: 'Phone'} || null
                        break
                    case 'Mail':
                        medium = value && {mail: value, contactMediumType: 'Mail'} || null
                        break
                    case 'Fax':
                        medium = value && {fax: value || null, contactMediumType: 'Fax'} || null
                        break
                }

                field.onChange(medium)
            }

            return {...field, disabled, value, onChange}
        }

        const callTypeField = () => {
            const value = callType

            const onChange = (callType) => {
                this._toggleCallType(callType)
            }

            return {value, onChange}
        }

        const hintField = () => {
            const value = hint || ''

            const onChange = (event) => {
                const hint = event.target.value || null

                const data = {
                    firstName: cmd.recipient && cmd.recipient.namez && cmd.recipient.namez.firstName,
                    lastName: cmd.recipient && cmd.recipient.namez && cmd.recipient.namez.lastName,
                    value: cmd.recipient && cmd.recipient.namez && cmd.recipient.namez.value || i18n.namePlaceholder,
                    name: cmd.recipient && cmd.recipient.provider && cmd.recipient.provider.name,
                    phone: cmd.medium && phonez(cmd.medium.phone).format() || i18n.phonePlaceholder
                }
                const comment = replace(extract(i18n.emitCallCommentEnum, hint, null), data)

                const interventionCmdTypes = restrictInterventionCmdTypes(ticket, hint)

                dispatch(updateEmitCallToCmd({comment}))

                this.setState({hint, interventionCmdTypes, interventionCmdType: null})
            }

            return {value, onChange}
        }

        const interventionCmdTypeField = () => {
            const value = interventionCmdType

            const onChange = (value) => {
                const interventionCmdType = value
                this.setState({interventionCmdType})

                const interventionAcceptedChoosen = {interventionAcceptedClicked: value === 'AcceptIntervention'}

                dispatch(updateEmitCallToCmd({...interventionAcceptedChoosen}))
            }

            return {value, onChange}
        }

        return (
            <Modal
                onHide={this._hide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{extract(i18n.emitCallEnum, callType)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={style.defaultContent}>
                        {callTypes.length > 1 && (
                            <div className={style.callType}>
                                <Row>
                                    <Col sm={9} smOffset={3}>
                                        <ButtonToggle
                                            {...callTypeField()}>
                                            <ul className={style.container}>
                                                {callTypes.map((callType, index) => (
                                                    <li
                                                        key={index}>
                                                        <Button
                                                            bsStyle='link'
                                                            value={callType}>
                                                            <Icon
                                                                icon='clientAccountManager'
                                                                size='md'/>
                                                            <span>{extract(i18n.emitCallzEnum, callType)}</span>
                                                        </Button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </ButtonToggle>
                                    </Col>
                                </Row>
                            </div>
                        )}
                        <h5>
                            <span>{i18n.contactDetails}</span>
                        </h5>
                        <form className='form-horizontal'>
                            {form.recipient.namez && form.recipient.namez.gender && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='select'
                                    name='gender'
                                    label={i18n.gender}
                                    {...form.recipient.namez.gender()}>
                                    <option value=''></option>
                                    <option value='Male'>{i18n.genderEnum.male}</option>
                                    <option value='Female'>{i18n.genderEnum.female}</option>
                                </Input>
                            )}
                            {form.recipient.namez && form.recipient.namez.firstName && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='firstName'
                                    label={requiredLabel(i18n.firstName)}
                                    {...form.recipient.namez.firstName()} />
                            )}
                            {form.recipient.namez && form.recipient.namez.lastName && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='lastName'
                                    label={requiredLabel(i18n.lastName)}
                                    {...form.recipient.namez.lastName()} />
                            )}
                            {form.recipient.namez && form.recipient.namez.value && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='name'
                                    label={requiredLabel(i18n.name)}
                                    {...form.recipient.namez.value()} />
                            )}
                            {cmd && cmd.recipient.provider && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='provider'
                                    disabled={true}
                                    label={i18n.provider}
                                    value={cmd.recipient.provider.name}/>
                            )}
                            {hints.length > 0 && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='select'
                                    label={i18n.callReason}
                                    {...hintField()}>
                                    <option value=''>{i18n.callReason} ...</option>
                                    {hints.map((hint) => (
                                        <option
                                            key={hint}
                                            value={hint}>
                                            {extract(i18n.emitCallHintEnum, hint)}
                                        </option>
                                    ))}
                                </Input>
                            )}
                        </form>
                        <form className='form-horizontal'>
                            {mediums.length == 0 && (
                                <div>
                                    <Input
                                        labelClassName='col-sm-3'
                                        wrapperClassName='col-sm-9'
                                        type='text'
                                        name='phone'
                                        label={i18n.phone}
                                        addonBefore={inputAddon('phone')}
                                        {...phoneField(mediumField(form.medium(), 'Phone'))} />
                                    <Input
                                        labelClassName='col-sm-3'
                                        wrapperClassName='col-sm-9'
                                        type='text'
                                        name='email'
                                        label={i18n.email}
                                        addonBefore={inputAddon('mail')}
                                        {...mediumField(form.medium(), 'Mail')} />
                                    <Input
                                        labelClassName='col-sm-3'
                                        wrapperClassName='col-sm-9'
                                        type='text'
                                        name='fax'
                                        label={i18n.fax}
                                        addonBefore={inputAddon('fax')}
                                        {...phoneField(mediumField(form.medium(), 'Fax'))} />
                                </div>
                            )}
                            <h5><small>{i18n.contactDetailsText} <i>*</i></small></h5>
                            {mediums.filter((m) => m.contactMediumType == 'Phone').map((medium, index) => (
                                <Input disabled
                                       key={index}
                                       labelClassName='col-sm-3'
                                       wrapperClassName='col-sm-9'
                                       type='text'
                                       name='phone'
                                       label={index == 0 && i18n.phone || ' '}
                                       addonBefore={inputAddon('phone')}
                                       buttonAfter={mediumInputButton(medium)}
                                       value={phonez(medium.phone).format()}
                                       bsStyle={form.medium().bsStyle}/>
                            ))}
                            {mediums.filter((m) => m.contactMediumType == 'Mail').map((medium, index) => (
                                <Input disabled
                                       key={index}
                                       labelClassName='col-sm-3'
                                       wrapperClassName='col-sm-9'
                                       type='text'
                                       name='email'
                                       label={index == 0 && i18n.email || ' '}
                                       addonBefore={inputAddon('mail')}
                                       buttonAfter={mediumInputButton(medium)}
                                       value={medium.mail}
                                       bsStyle={form.medium().bsStyle}/>
                            ))}
                            {mediums.filter((m) => m.contactMediumType == 'Fax').map((medium, index) => (
                                <Input disabled
                                       key={index}
                                       labelClassName='col-sm-3'
                                       wrapperClassName='col-sm-9'
                                       type='text'
                                       name='fax'
                                       label={index == 0 && i18n.fax || ' '}
                                       addonBefore={inputAddon('fax')}
                                       buttonAfter={mediumInputButton(medium)}
                                       value={phonez(medium.fax).format()}
                                       bsStyle={form.medium().bsStyle}/>
                            ))}
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='textarea'
                                name='comment'
                                label={i18n.comment}
                                rows={4}
                                {...controlledField(form.comment())} />
                        </form>
                        {hint == 'callerSatisfaction' && (
                            <div>
                                <h5>{i18n.satisfaction} <i>*</i></h5>
                                <AnswerForm
                                    ref='answerForm'
                                    ticket={ticket}/>
                            </div>
                        )}

                        <form className='form-horizontal'>
                            {interventionCmdTypes.length !== 0 && <h5>{i18n.interventionModalDetail}</h5>}
                            <Row>
                                <Col sm={9} smOffset={3}>
                                    <RadioToggle
                                        {...interventionCmdTypeField()}>
                                        <ul className={style.interventionCmdType}>
                                            {interventionCmdTypes.map((interventionCmdType, index) => (
                                                <li
                                                    key={index}>
                                                    <label>
                                                        <input
                                                            type='radio'
                                                            value={interventionCmdType}/>
                                                        {extract(i18n.interventionCmdTypeEnum, interventionCmdType)}
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>
                                    </RadioToggle>
                                </Col>
                            </Row>


                            {this.emailStuff()}
                        </form>

                        <ButtonToolbar>
                            <LoaderButton
                                bsStyle='primary'
                                bsSize='large'
                                className={cx({disabled: !this._isValid()})}
                                onClick={() => this._validate() && this._send() || dispatch(errorStatus(i18n.formInvalid))}>
                                {i18n.validate}
                            </LoaderButton>
                            <Button
                                bsSize='large'
                                onClick={this._hide}>
                                {i18n.cancel}
                            </Button>
                        </ButtonToolbar>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

EmitCallToModal = connectForm({
    validator: createValidator(),
    target: 'cmd',
    schema: EmitCallToCmd.selectSchema,
    action: EMIT_CALL_TO_CMD_UPDATED
})(EmitCallToModal)

EmitCallToModal = connect((state) => ({
    ticket: state.ticket.ticket,
    acceptInterventionCmd: state.ticket.acceptInterventionCmd,
    cmd: state.ticket.emitCallToCmd
}))(EmitCallToModal)

export default EmitCallToModal


// WEBPACK FOOTER //
// ./lib/ticket/components/EmitCallToModal.js